import { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import Select from "react-select";
import SimpleReactValidator from "simple-react-validator";
import { Col, Row, Form, Spinner } from "react-bootstrap-v5";
import { DutyAndTaxService  } from "../../Services/DutyAndTaxService";
import { useHistory } from "react-router-dom";
import { locationServices } from "../../Services";

export const AddDutyAndTax = () => {
  const [, setForceUpdate] = useState("");
  const [countryList, setCountryList] = useState([]);
  const [loader, setLoader] = useState(false);
  const [state, setState] = useState({
    country: "",
    description: "",
    duty: "",
    tax: "",
  });
  const history = useHistory();

  const Validator = useRef(
    new SimpleReactValidator({
      autoForceUpdate: { forceUpdate: setForceUpdate },
    })
  );

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState({ ...state, [name]: value });
  };

  const handleSelectChange = (e) => {
    setState({ ...state, [e.name]: e.value });
  };

  const handleSubmit = () => {
    let validate = Validator.current.allValid();
    if (validate) {
      let params = { ...state };
      setLoader(true);
      DutyAndTaxService.addDutyAndTax(params).then((res) => {
        if (res.status) {
          toast.success(res.message);
          history.push("/duty-and-tax-list");
          setLoader(false);
        } else {
          setLoader(false);
          toast.error(res.message);
        }
      });
    } else {
      Validator.current.showMessages();
    }
  };

  const getCountryList = () => {
    locationServices.getCountry().then((res) => {
      if (res.status) {
        let arry = [];
        res.data.map((list) => {
          arry.push({
            value: list.country_name,
            label: list.country_name,
          });
        });
        setLoader(false);
        setCountryList(arry);
      }
    });
  };
  useEffect(() => {
    getCountryList();
  }, []);

  return (
    <div style={{ height: "500px" }}>
      <div className="row" style={{ width: "50%" }}>
        <div className="card">
          <div className="card-body">
            <Form autoComplete="off">
              <Row className="p-3">
                {/* country  */}
                <Col md={6} className="mb-1">
                  <Form.Label>Country</Form.Label>
                  <Select
                    styles={{
                      valueContainer: (provided) => ({
                        ...provided,
                        overflowY: "visible",
                      }),
                    }}
                    placeHolder="Select Country"
                    onChange={(e) =>
                      handleSelectChange({ name: "country", value: e.value })
                    }
                    options={countryList}
                  />

                  {Validator.current.message(
                    "Country",
                    state.country,
                    "required",
                    { className: "text-danger" }
                  )}
                </Col>

                {/* description  */}
                <Col md={6} className="mb-1">
                  <Form.Label>Description</Form.Label>
                  <Form.Control
                    type="email"
                    name="description"
                    onChange={(e) => handleChange(e)}
                    placeholder="Enter Description"
                    value={state.description}
                    autoComplete="new-password"
                  />
                  {Validator.current.message(
                    "Description",
                    state.description,
                    "required",
                    {
                      className: "text-danger",
                    }
                  )}
                </Col>
              </Row>
              <Row className="p-3">
                {/* duty  */}
                <Col md={6} className="mb-3">
                  <Form.Label>Duty %</Form.Label>
                  <Form.Control
                    type="text"
                    name="duty"
                    onChange={(e) => handleChange(e)}
                    placeholder="Enter Duty"
                    value={state.duty}
                  />
                  {Validator.current.message("Duty", state.duty, "required", {
                    className: "text-danger",
                  })}
                </Col>

                {/* tax  */}
                <Col md={6} className="mb-3">
                  <Form.Label>Tax %</Form.Label>
                  <Form.Control
                    type="email"
                    name="tax"
                    onChange={(e) => handleChange(e)}
                    placeholder="Enter Tax"
                    value={state.tax}
                    autoComplete="new-password"
                  />
                  {Validator.current.message("Tax", state.tax, "required", {
                    className: "text-danger",
                  })}
                </Col>
              </Row>

              <Row className="mt-3">
                <Col md={12} className="d-flex justify-content-center">
                  <button
                    className="btn btn-danger w-sm waves-effect waves-light"
                    type="button"
                    onClick={() => history.goBack()}
                  >
                    Back
                  </button>
                  <button
                    className="btn btn-primary w-sm waves-effect waves-light ms-3"
                    type="button"
                    onClick={handleSubmit}
                  >
                    {(loader && <Spinner animation="grow" size="sm" />) ||
                      "Submit"}
                  </button>
                </Col>
              </Row>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
};
